import React, { Component } from "react";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import Lottie from 'lottie-react-web'
import animationData from "../../../lotties/33623-piggy-bank-loop.json";
import ItemsCarousel from 'react-items-carousel';
import { ResponsiveBar } from '@nivo/bar'
import { ResponsiveLine } from '@nivo/line'
import Modal from 'react-modal'
import InputRange from 'react-input-range';
// import '../../../../node_modules/react-input-range/lib/css/index.css';
import 'react-input-range/lib/css/index.css';


const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };

class TableroProductos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valSearch: '',
      findProducts: true,
      arrListVentaByDay: [],

    }
  }

  componentDidMount() {

  }

  render() {
    const { isLoading, valSearch, findProducts, arrListVentaByDay, } = this.state
    const { filterBy, arrProductos, indexProducto, arrProductosMetadata, } = this.props.mainState

    if(isLoading) {
      return (
        <div className="directorPage__wrapper" style={{ marginTop: 0, }}>
          {/*<Lottie
            direction={1}
            options={{
              animationData: animationData,
              loop: true,
            }}
            />*/}
        </div>
      )
    }

    return (
      <Container className="directorPage__wrapper"  style={{ marginTop: 0, }}>

        {
          filterBy === 'listaProductos' ? (
            <div>
              
              <p style={{margin: 0, marginTop: 4,}}>Por favor indica el producto que deseas visualizar</p> 
              <Row>
                <Col xs={8}>
                  <input
                    type="text"
                    id={'ws-input-search-code'}
                    autoComplete="off"
                    placeholder="Ingresa el nombre del producto..."
                    value={valSearch}
                    onChange={(e) => this.setState({ valSearch: e.target.value}) } 
                    // onKeyDown={this._handleKeyDown}
                    style={{ width: '100%', background: '#f3f3f3', border: '1px solid #ccc', borderRadius: 4, padding: 5, marginTop: 6, }}
                  />
                </Col>
                <Col>
                  <button style={{ margin: 0, marginTop: 5, }} className={`btn btn-${valSearch.trim() == '' ? 'secondary' : 'primary' }`} onClick={() => { this.onSearchProducto() }}>Generar</button>
                </Col>
              </Row>

              {
                arrProductos.length == 0 && !findProducts ? (
                  <p>No se encontraron resultados en la búsqueda con la palabra</p>
                ) : (
                  <>
                  {
                    arrProductos.map((t,e) => (
                      <Row className={'ws__listNthChild'}
                        onClick={() => { this.onSelectProducto(e) }}
                      >
                        <Col xs={8}>
                          <p style={{margin: 0, fontSize: '.9rem', fontWeight: 800, }}>{t.nombre}</p>
                          <p style={{margin: 0, fontSize: '.7rem', }}>Actualizado: {t.fecha_cambio_costo}</p>
                        </Col>
                        <Col>
                          <p style={{margin: 0, fontSize: '.9rem', marginTop: 5, }}>${this.number_format(t.precio_venta,2)}</p>
                        </Col>
                      </Row>
                    ))
                  }
                  </>
                )
              }

            </div>
          ) : null
        }
        
        {
          filterBy === 'viewGraph' ? (
            <div>
              
              <p style={{margin: 0, marginTop: 4,}} onClick={() => { this.props.mainsetState({filterBy: 'listaProductos' }) }}>Regresar</p>
              <p style={{margin: 0, marginTop: 4,}}>{arrProductos[indexProducto].nombre}</p>

              { this.makeGraphBar() } 

              <hr />

              <Row>
                <Col xs={2}>
                  <p>Fecha</p>
                </Col>
                <Col>
                  <p>KG vendidos</p>
                </Col>
                <Col>
                  <p>Venta $</p>
                </Col>
                <Col>
                  <p>Crédito</p>
                </Col>
                <Col>
                  <p>P. Unitario</p>
                </Col>
              </Row>

              {
                arrProductosMetadata.venta.map((t,e) => (
                  <Row onClick={() => {
                    this.onLoadInfoByDay(t,e)
                  }} className={'ws__listNthChild'}>
                    <Col xs={2}>
                      <p>{ moment(t.fecha).format('DD/MM/YYYY') }</p>
                    </Col>
                    <Col>
                      <p>{ this.number_format(t.kg, 2) }</p>
                    </Col>
                    <Col>
                      <p>${ this.number_format(t.venta_pesos, 2) }</p>
                    </Col>
                    <Col>
                      <p>${ this.number_format(t.credito, 2) }</p>
                    </Col>
                    <Col>
                      <p>${ this.number_format(t.precio_unitario, 2) }</p>
                    </Col>
                  </Row>
                ))
              }

              <Row>
                <Col xs={2}>
                  <p>Total: </p>
                </Col>
                <Col>
                  <p>{ this.number_format(arrProductosMetadata.total_kg, 2) }</p>
                </Col>
                <Col>
                  <p>${ this.number_format(arrProductosMetadata.total_venta_pesos, 2) }</p>
                </Col>
                <Col>
                  <p>${ this.number_format(arrProductosMetadata.total_credito, 2) }</p>
                </Col>
                <Col>-</Col>
              </Row>

            </div>
          ) : null
        }

        <Modal
          overlayClassName="Overlay__aplicaciones"
          isOpen={this.state.isOpenViewListDay}
          onRequestClose={() => { this.setState({ isOpenViewListDay: false}) }}
          style={customStyles}
          contentLabel=""
          >
          <div className="modalBody__operador">
            <Row className="modalBody__corte"> 
              <Col>
                <h4>Reporte de venta diaria.</h4>

                
                <Row>
                  <Col xs={2}>
                    <p>Fecha</p>
                  </Col>
                  <Col>
                    <p>KG vendidos</p>
                  </Col>
                  <Col>
                    <p>Venta $</p>
                  </Col>
                  <Col>
                    <p>Crédito</p>
                  </Col>
                  <Col>
                    <p>P. Unitario</p>
                  </Col>
                </Row>

                {
                  arrListVentaByDay.map((t,e) => (
                    <Row className={'ws__listNthChild'}>
                      <Col xs={2}>
                        <p>{ moment(t.fecha).format('DD/MM/YYYY') }</p>
                      </Col>
                      <Col>
                        <p>{ this.number_format(t.kg, 2) }</p>
                      </Col>
                      <Col>
                        <p>${ this.number_format(t.venta_pesos, 2) }</p>
                      </Col>
                      <Col>
                        <p>${ this.number_format(t.credito, 2) }</p>
                      </Col>
                      <Col>
                        <p>${ this.number_format(t.precio_unitario, 2) }</p>
                      </Col>
                    </Row>
                  ))
                }

              </Col>
            </Row>
          </div>
        </Modal>
        
      </Container>
    )
  }

  onLoadInfoByDay(t,e) {
    let {
      finit, ffin,
      indexProducto, indexCategoria, indexSucursal,
      arrProductos, arrCategorias, arrSucursales
    } = this.props.mainState

    if(indexSucursal == -1) {
      alert('Por favor indica la sucursal a evaluar.')
      return false
    }

    let data = {
      id_producto: indexProducto > -1 ? arrProductos[indexProducto].id_producto : ''  ,
      id_categoria: indexCategoria > -1 ? arrCategorias[indexCategoria].id_categoria : ''  ,
      id_sucursal: indexSucursal > -1 ? arrSucursales[indexSucursal].id_sucursal : ''  ,
      day: t.fecha,
    }

    fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp.php?opt=getInfoVentasByDay", this.headersPOST({ ...data, }))
    .then(response => response.json())
    .then((response) => {
      this.setState({
        isOpenViewListDay: true,
        arrListVentaByDay: response,
      })
      console.log(response)
      // this.props.mainsetState({ arrProductos: response.arrProductos, });
      // this.setState({ isLoading: false, findProducts: (response.arrProductos.length == 0 ? false : true) })
    })

  }

  makeGraphBar() {
    let { arrProductosMetadata, arrKG, } = this.props.mainState
    if(arrKG.length == 0) {
      return <p>Generando gráfica....</p>
    }

    let arr1 = [],
    arr2 = [],
    concepto1 = '',
    concepto2 = ''

    if(this.props.mainState.typeGraph == 1) {
      concepto1 = "$ Diario"
      concepto2 = "$ Acumulado"
      arr1 = this.props.mainState.arrVentaPesos
      arr2 = this.props.mainState.arrAcumVentaPesos
    } else if(this.props.mainState.typeGraph == 2) {
      concepto1 = "Créd Diario"
      concepto2 = "Créd Acumulado"
      arr1 = this.props.mainState.arrCredito
      arr2 = this.props.mainState.arrAcumCredito
    } else if(this.props.mainState.typeGraph == 3) {
      concepto1 = "KG Diario"
      concepto2 = "KG Acumulado"
      arr1 = this.props.mainState.arrKG
      arr2 = this.props.mainState.arrAcumKG
    }

    const dataLine = [{
      "id": concepto1,
      "color": "hsl(214, 70%, 50%)",
      "data": arr1,
    }, {
      "id": concepto2,
      "color": "hsl(134, 70%, 50%)",
      "data": arr2,
    }]

    return (
      <div style={{ width: (this.props.initState.width - 20), height: '400px', }}>

        <hr />
        <div style={{ width: '80%', }} >
          
          <InputRange
            minValue={1}
            maxValue={31}
            value={this.props.mainState.valueLarge}
            onChange={valueLarge => this.props.mainsetState({ valueLarge, })} />
            <button
              onClick={() => {
                this.props.generateInfoArrayBar()
              }}
              className={'btn btn-seconday'}
            >Ajustar</button>
        </div>
        <Row>
          <Col>
            <p
              onClick={() => { this.props.mainsetState({ typeGraph: 1 }) }}
            >Pesos</p>
          </Col>
          <Col>
            <p
              onClick={() => { this.props.mainsetState({ typeGraph: 2 }) }}
            >Crédito</p>
          </Col>
          <Col>
            <p
              onClick={() => { this.props.mainsetState({ typeGraph: 3 }) }}
            >KG</p>
          </Col>

        </Row>
        <hr />

        <ResponsiveLine
          data={dataLine}
          margin={{ top: 50, right: 110, bottom: 100, left: 60 }}
          width={(this.props.initState.width - 20)}
          height={300}
          xScale={{ type: 'point' }}
          yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
          yFormat=" >-.2f"
          axisTop={null}
          axisRight={null}
          axisBottom={{
            orient: 'bottom',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Meses',
            legendOffset: 36,
            legendPosition: 'middle'
          }}
          axisLeft={{
            orient: 'left',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Categorías',
            legendOffset: -40,
            legendPosition: 'middle'
          }}
          pointSize={10}
          pointColor={{ theme: 'background' }}
          pointBorderWidth={2}
          pointBorderColor={{ from: 'serieColor' }}
          pointLabelYOffset={-12}
          useMesh={true}
          legends={[{
            anchor: 'bottom-right',
            direction: 'column',
            justify: false,
            translateX: 100,
            translateY: 0,
            itemsSpacing: 0,
            itemDirection: 'left-to-right',
            itemWidth: 80,
            itemHeight: 20,
            itemOpacity: 0.75,
            symbolSize: 12,
            symbolShape: 'circle',
            symbolBorderColor: 'rgba(0, 0, 0, .5)',
            effects: [{
              on: 'hover',
              style: {
                itemBackground: 'rgba(0, 0, 0, .03)',
                itemOpacity: 1
              }
            }]
          }]}
        />
      </div>
    )

  }

  onSelectProducto(e) {
    let { arrProductos } = this.props.mainState
    const item = arrProductos[e]

    this.props.mainsetState({
      indexProducto: e,
      indexCategoria: -1,
      indexSucursal: -1,
      filterBy: 'viewGraph',
    }, this.props.maingetGeneral )

  }

  onSearchProducto() {
    let { valSearch } = this.state

    if(valSearch.trim() == '') {
      alert('Por favor, escribe algo')
      return false
    }

    let data = {
      valSearch,
    }

    this.setState({ isLoading: true, })

    fetch("https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/controllerWebApp.php?opt=getProductosByNameSearch", this.headersPOST({ ...data, }))
    .then(response => response.json())
    .then((response) => {
      this.props.mainsetState({ arrProductos: response.arrProductos, });
      this.setState({ isLoading: false, findProducts: (response.arrProductos.length == 0 ? false : true) })
    })
  }

  pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  getStyleModal(opt) {
    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  getColorByIndex(e) {
    const color = ['#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3','#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3']
    return color[e]
  }


  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

 getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://diana.wsoft.com.mx/pos/multiservicios/REST/controllers/${PHP}?opt=${opt}`
  }


}

export default withRouter(TableroProductos)